import React from 'react';
import { Box, Typography, Paper } from '@material-ui/core';
import { formatPrice } from 'common/functions';
import { DEFAULT_PAPER_ELEVATION } from 'common/constants';
import { makePaperClasses, makePriceClasses, makeSummaryTitleClasses } from 'styles/pages/checkout';
import { DotsLoader } from '../../../common/loaders';

type Props = {
    loading?: boolean;
    sumPrice: number;
};

const Summary: React.FC<Props> = ({ loading, sumPrice }) => {
    const paperClasses = makePaperClasses();
    const priceClasses = makePriceClasses();
    const titleClasses = makeSummaryTitleClasses();

    return (
        <Paper classes={paperClasses} elevation={DEFAULT_PAPER_ELEVATION} square>
            {loading ? (
                <DotsLoader />
            ) : (
                <Box py={2} px={3}>
                    <Typography classes={titleClasses} component="h3" variant="body1">
                        Podsumowanie
                    </Typography>
                    Wartość zamówienia:{' '}
                    <Typography classes={priceClasses} component="span">
                        {formatPrice(sumPrice)}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default Summary;
